/*============ confirmUsernameController
 ================================*/
 angular
 .module('vppApp')
 .controller('confirmUsernameController', confirmUsernameController);

 confirmUsernameController.$inject = ['$scope', '$rootScope', '$location', 'vppConfig', 'apiFactory', '$state', '$http', 'AuthenticationService', 'DTMTrackerService', 'ThirdPartyMessages'];

function confirmUsernameController($scope, $rootScope, $location, vppConfig, apiFactory, $state, $http, AuthenticationService, DTMTrackerService, ThirdPartyMessages) {
 $scope.hideMe = false;
 if ($state.current.name === 'sign-in') { AuthenticationService.destroyAuthentication(); };
 var userEmail;
 $scope.signInTemplate;
 if ($rootScope.siteCode === 'mpp') {
   $scope.signInTemplate = '/content/html/partials/global/idmesignin.html';
 } else if ($rootScope.siteCode === 'frd'){
   $scope.signInTemplate = '/content/html/partials/global/frdsignin.html';
 } else {
   $scope.signInTemplate = '/content/html/partials/global/sitesignin.html';
 }

 apiFactory.getSsoUrl().then(function (response) {
     $scope.ssoUrl = response.data;
 });

 $scope.submitSignIn = function(userData) {
     userEmail = userData.username;
     userData.Token = $location.search().token;

    var body = {"username" : userData.username, "password" : userData.password, "verificationCode" : userData.Token};

    apiFactory.changeUsernameConfirm(body)
        .then(function successSignIn(response) {
            ThirdPartyMessages.setMessage('verification', '');
            $state.go("index");
            // this callback will be called asynchronously
            // when the response is available
        }, function errorCallback(response) {
            $scope.serverError = response.data.errors;
        });
 };


 $scope.submitSignOut = function() {
     apiFactory.signOut()
         .then(function successSignOut(response) {
             if (response.data.url != null){
                 $window.location.href = response.data.url;
             }else{
                 $state.go("index");
             }
             // this callback will be called asynchronously
             // when the response is available
         }, function errorCallback(response) {
             $scope.serverError = response.data.errors;
             // called asynchronously if an error occurs
             // or server returns response with an error status.
         });
 };

 $scope.idMeFactoryCall = function() {
     apiFactory.idMeAccessUserData().then(function(response) {
         $scope.user = response.data;
         //$rootScope.idmeFRD = true;
         var accountId = response.data.accountID;
         var userEmail = response.data.email;
         var collectMoreInfo = response.data.requireAdditionalData;
         DTMTrackerService.directCall("signin-complete");
         if (collectMoreInfo === true) {
             AuthenticationService.setAuthentication(response, userEmail);
             $state.go('create-account');
         } else{
             apiFactory.getProfileDetails(accountId).then(function(thisResponse) {
                 userEmail = thisResponse.data.customerDetails.emailAddress;
                 AuthenticationService.setAuthentication(response, userEmail);
                 $state.go('view-auth');
             });

         }

     }, function errorCallback(response) {
         $scope.serverError = response.data.errors;
         // called asynchronously if an error occurs
         // or server returns response with an error status.

     });
 };
 $scope.dispSignIn = function(userData) {
   $scope.hideMe = true;
 };
}